<template>
  <section class="cheque-queue">
    <h1>Bank Transfer Queue</h1>
    <section class="main">
      <el-tabs v-model="activeTab">
        <el-tab-pane
          v-for="(tab, index) in tabList"
          :key="index"
          :label="tab.label"
          :name="tab.name"
        ></el-tab-pane>
      </el-tabs>
      <section v-show="activeTab === 'New'">
        <div class="text-right">
          <v-button
            :disabled="disabledBtn"
            @click="handlerClearSelectionNew">Clear Selection</v-button>
          <v-button
            :disabled="disabledBtn"
            type="primary"
            @click="handlerExport">Export</v-button>
          <v-button
            :disabled="disabledBtn"
            type="success"
            @click="handlerMark">Mark as Done</v-button>
        </div>
        <div class="transparent">
          <el-table
            ref="newTable"
            :data="tableData"
            stripe
            style="width: 100%"
            @selection-change="handleNewSelectionChange">
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              width="100px"
              prop="id"
              label="ID"></el-table-column>
            <el-table-column
              prop="action_language"
              width="120px"
              label="Type"></el-table-column>
            <el-table-column
              prop="card_number"
              label="Bank Account No."></el-table-column>
            <el-table-column
              prop="card_bank"
              label="Bank"></el-table-column>
            <el-table-column
              prop="card_holder"
              width="200px"
              label="Bank Account Holder"></el-table-column>
            <el-table-column
              label="Reason">
              <template #default="{ row }">
                <span
                  v-if="row.ticket_id"
                  class="blue pointer"
                  @click="routerTicket(row.ticket_id)">Credit Transfer #{{ row.ticket_id }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="amount"
              label="Amount">
            </el-table-column>
            <el-table-column
              prop="added_date"
              label="Added Date">
            </el-table-column>
          </el-table>
        </div>
      </section>
      <section v-show="activeTab === 'Done'">
        <div class="text-right mg-b-15">
          <v-button
            type="primary"
            @click="onOpenExportAgainDialog">Export Again</v-button>
        </div>
        <div class="card filter-card">
          <div class="search-box flex">
            <span>Search</span>
            <v-input
              v-model="formData.search"
              placeholder="ID, Bank Account No., Bank Account Holder"
              @blur="filterDoneList" />
          </div>
          <div class="filter-container">
            <div class="form-item">
              <span>Bank</span>
              <v-select
                v-model="formData.bank_code"
                :list="globalOptions.banks"
                valueKey="code"
                :clearable="true"
                @change="filterDoneList" />
            </div>
            <div class="form-item">
              <span>Added Date</span>
              <v-date-picker
                v-model="addedDate"
                type="daterange"
                @change="filterDoneList" />
            </div>
            <div class="form-item">
              <span>Done Date</span>
              <v-date-picker
                v-model="doneDate"
                type="daterange"
                @change="filterDoneList" />
            </div>
            <div class="form-item">
              <span>Amount</span>
              <v-input-range
                v-model="amountRange"
                @blur="filterDoneList" />
            </div>
          </div>
        </div>
        <!-- <div class="text-right">
          <v-button
            :disabled="disabledDoneBtn"
            @click="handlerClearSelection">Clear Selection</v-button>
          <v-button
            :disabled="disabledDoneBtn"
            type="primary"
            @click="downloadDoneSelection">Download Again</v-button>
        </div> -->
        <div class="transparent">
          <el-table
            ref="doneTable"
            :data="doneTableData"
            stripe
            style="width: 100%"
            @selection-change="handleDoneSelectionChange">
            <el-table-column
              prop="id"
              width="100px"
              label="ID"></el-table-column>
            <el-table-column
              prop="action_language"
              width="120px"
              label="Type"></el-table-column>
            <el-table-column
              width="200px"
              prop="card_number"
              label="Bank Account No."></el-table-column>
            <el-table-column
              width="200px"
              prop="card_bank"
              label="Bank"></el-table-column>
            <el-table-column
              width="200px"
              prop="card_holder"
              label="Bank Account Holder"></el-table-column>
            <el-table-column
              width="180px"
              label="Reason">
              <template #default="{ row }">
                <span
                  v-if="row.ticket_id"
                  class="blue pointer"
                  @click="routerTicket(row.ticket_id)">Credit Transfer #{{ row.ticket_id }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="amount"
              label="Amount">
            </el-table-column>
            <el-table-column
              width="120px"
              prop="added_date"
              label="Added Date">
            </el-table-column>
            <el-table-column
              width="120px"
              prop="added_date"
              label="Done Date">
            </el-table-column>
            <el-table-column
              width="160px"
              prop="payment_number"
              label="Transaction No.">
            </el-table-column>
          </el-table>
        </div>

        <v-pagination
          :total="pageConfig.total"
          :current="pageConfig.currentPage"
          @currentChange="currentChange" />

      </section>
    </section>
    <!-- dialog -->
    <mark-done-dialog
      ref="mark-done-dialog"
      :selectionData="selectionList"
      @done="handlerMarkDone" />

    <v-dialog
      v-model="exportAgainDialog"
      width="300px">
      <div class="dialog-container">
        <h2>Export Again</h2>
        <div class="form-item">
          <span>Done Date</span>
          <v-date-picker
            v-model="exportDoneDate"
            type="daterange" />
        </div>
        <div class="flex-sb">
          <v-button @click="onExportCancel">Cancel</v-button>
          <v-button
            type="primary"
            :disabled="!exportDoneDate || exportDoneDate.length < 2"
            @click="onExportDone">Done</v-button>
        </div>
      </div>
    </v-dialog>

  </section>
</template>
<script>
import MarkDoneDialog from './components/dialogs/mark-done'
import {
  getCreditlist,
  getCreditDonelist,
  getCreditListDownload,
  getCreditDoneListDownload
} from '@/api/credits'
import { downloadFile } from '@/utils/download'
import MixinOptions from '@/mixins/options'

export default {
  name: 'ChequeQueue',
  components: {
    MarkDoneDialog
  },
  mixins: [MixinOptions],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      activeTab: 'New',
      tabList: [
        {
          label: 'New',
          name: 'New'
        },
        {
          label: 'Done',
          name: 'Done'
        }
      ],
      tableData: [],
      doneTableData: [],
      selectionList: [],
      selectionDoneList: [],
      addedDate: [],
      doneDate: [],
      amountRange: [],
      formData: {
        search: '',
        bank_code: ''
      },
      exportDoneDate: [],
      exportAgainDialog: false,
    }
  },
  computed: {
    disabledBtn() {
      return this.selectionList.length <= 0
    },
    disabledDoneBtn() {
      return this.selectionDoneList.length <= 0
    },
    selectionIdList() {
      return this.selectionList.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
    }
  },
  watch: {
    activeTab: {
      handler(val) {
        if(val === 'New') {
          this.network().getCreditlist()
        }
        if(val =='Done')
          this.network().getCreditDonelist()
      }
    }
  },
  created() {
    this.network().getCreditlist()
    this.network().getCreditDonelist()
  },
  methods: {
    routerTicket(ticketId) {
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: ticketId
        }
      })
    },
    onOpenExportAgainDialog() {
      this.exportDoneDate = []
      this.exportAgainDialog = true
    },
    onExportCancel() {
      this.exportAgainDialog = false
    },
    onExportDone() {
      this.network().getCreditDoneListDownload()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getCreditDonelist()
    },
    filterDoneList() {
      this.pageConfig.currentPage = 0
      this.network().getCreditDonelist()
    },
    handlerMark() {
      this.$refs['mark-done-dialog'].changeDialog()
    },
    handleDoneSelectionChange(val) {
      this.selectionDoneList = val
    },
    handleNewSelectionChange(val) {
      this.selectionList = val
    },
    handlerClearSelection() {
      this.$refs.doneTable.clearSelection()
    },
    handlerClearSelectionNew() {
      this.$refs.newTable.clearSelection()
    },
    downloadDoneSelection() {

    },
    handlerExport() {
      this.network().getCreditListDownload()
    },
    markDoneNewSelection() {

    },
    handlerMarkDone(data) {
      this.$message({
        type: 'success',
        message: data.message_language
      })
      this.network().getCreditlist()
    },
    network() {
      return {
        getCreditlist: async (params = {}) => {
          const { data } = await getCreditlist(params)
          this.tableData = data.data
        },
        getCreditDonelist: async (params = {}) => {
          const lastParams = {
            // min_amount: this.amountRange[0],
            // max_amount: this.amountRange[1],
            added_date_start: this.addedDate[0],
            added_date_end: this.addedDate[1],
            done_date_start: this.doneDate[0],
            done_date_end: this.doneDate[1],
          }
          if(this.amountRange[0]) {
            lastParams.min_amount = this.amountRange[0]
          }
          if(this.amountRange[1]) {
            lastParams.max_amount = this.amountRange[1]
          }
          // 空字符串會校驗報錯
          if(this.formData.search) {
            lastParams.search = this.formData.search
          }
          if(this.formData.bank_code) {
            lastParams.bank_code = this.formData.bank_code
          }
          const { data } = await getCreditDonelist({
            ...lastParams,
            ...params,
            page: this.pageConfig.currentPage,
          })
          this.doneTableData = data.data
          this.pageConfig.total = data.meta.total
        },
        getCreditListDownload: async () => {
          const res = await getCreditListDownload({
            transfer_id: this.selectionIdList
          })
          downloadFile(res)
        },
        getCreditDoneListDownload: async () => {
          const lastParams = {
            // min_amount: this.amountRange[0],
            // max_amount: this.amountRange[1],
            added_date_start: this.addedDate[0],
            added_date_end: this.addedDate[1],
            done_date_start: this.exportDoneDate[0],
            done_date_end: this.exportDoneDate[1],
          }
          if(this.amountRange[0]) {
            lastParams.min_amount = this.amountRange[0]
          }
          if(this.amountRange[1]) {
            lastParams.max_amount = this.amountRange[1]
          }
          // 空字符串會校驗報錯
          if(this.formData.search) {
            lastParams.search = this.formData.search
          }
          if(this.formData.bank_code) {
            lastParams.bank_code = this.formData.bank_code
          }
          const res = await getCreditDoneListDownload({
            ...lastParams,
            page: this.pageConfig.currentPage
          })
          downloadFile(res)
          this.exportAgainDialog = false
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cheque-queue {
    position: relative;
    .transparent {
        margin-top: 15px;
    }
    .filter-card {
      padding: 0;
      .search-box {
        padding: 15px 15px;
        align-items: center;
        border-bottom: 1px solid #E1E4E8;
        span {
            display: block;
            padding-bottom: 5px;
            padding-right: 15px;
            font-size: 14px;
            font-weight: 500;
            color: #616266;
        }
      }
      .filter-container {
        display: flex;
        padding: 0;
        .form-item {
          flex: 1;
          padding: 15px;
          border-right: 1px solid #E1E4E8;
        }
      }
    }
    .dialog-container {
      padding: 15px;
    }
}
</style>
